import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader, Avatar  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';
import ban from '../../img/math.png'

export default class Modaleditexpert extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท

                name_expert : '', //ผู้นำเสนอ
                username_expert : '', //ผู้นำเสนอ
                password_expert : '', //ผู้นำเสนอ
                affiliation_expert : '', //ผู้นำเสนอ
                expertise_expert : '', //ผู้นำเสนอ
                tel_expert : '', //ผู้นำเสนอ
                adminaddby : '', //ผู้นำเสนอ
                iduser:'',

                id_expert:'',
                }
      
                this.toggle = this.toggle.bind(this);
                this.handleSubmit = this.handleSubmit.bind(this);
     
                this.handleChangesend_name = this.handleChangesend_name.bind(this);
                this.handleChangesend_username = this.handleChangesend_username.bind(this);
                this.handleChangesend_password = this.handleChangesend_password.bind(this);
                this.handleChangesend_affiliation = this.handleChangesend_affiliation.bind(this);
                this.handleChangesend_expertise = this.handleChangesend_expertise.bind(this);
                this.handleChangesend_tel = this.handleChangesend_tel.bind(this);
                this.getExpert = this.getExpert.bind(this);
             
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.getExpert();
}




 componentDidMount() {
   //    const { iduser } = this.props.iduser
    //   console.log(id_send);
       this.setState({ id_expert:this.props.id_expert})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

  getExpert() {
    setTimeout(() => {
      //ภายใน
      api.get('registercon/selectexpertedit/'+this.props.id_expert)
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
        if (res.data.length > 0) {
            this.setState({ id_expert: res.data[0].id_expert})
            this.setState({ name_expert: res.data[0].name_expert})
            this.setState({ username_expert: res.data[0].username_expert})
            this.setState({ password_expert: res.data[0].password_expert})
            this.setState({ affiliation_expert: res.data[0].affiliation_expert})
            this.setState({ expertise_expert: res.data[0].expertise_expert})
            this.setState({ tel_expert: res.data[0].tel_expert})
        } else {
            
        }
      }) 
    }, 0);

}


handleChangesend_name(event) {    this.setState({name_expert: event.target.value});  }
handleChangesend_username(event) {    this.setState({username_expert: event.target.value});  }
handleChangesend_password(event) {    this.setState({password_expert: event.target.value});  }
handleChangesend_affiliation(event) {    this.setState({affiliation_expert: event.target.value});  }
handleChangesend_expertise(event) {    this.setState({expertise_expert: event.target.value});  }
handleChangesend_tel(event) {    this.setState({tel_expert: event.target.value});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
    //  datafrm.append("send_id", this.props.iduser);
      datafrm.append("name_expert", this.state.name_expert);
      datafrm.append("username_expert", this.state.username_expert);
      datafrm.append("password_expert", this.state.password_expert);
      datafrm.append("affiliation_expert", this.state.affiliation_expert);
      datafrm.append("expertise_expert", this.state.expertise_expert);
      datafrm.append("tel_expert", this.state.tel_expert);
      datafrm.append("id_expert", this.state.id_expert);

     //  datafrm.append("agree_type", this.state.radio);
     //  datafrm.append("send_uploadeword12", this.state.send_uploadeword12);
     //  datafrm.append("send_uploadepdf12", this.state.send_uploadepdf12);
     // datafrm.append("send_date1", dates);

     //  datafrm.append("send_statuspay", this.state.send_statuspay);
     //  datafrm.append("stapat", this.state.stapat);

    api.post("registercon/updateexpertforadmin",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.data = '200') {
     // message.success("อัพโหลไฟล์สำเร็จ")
    //  this.setState({ id_send: ""})
     // window.location.href = '/adminfaculty'
     Swal.fire({
      title: 'แก้ไขข้อมูลผู้ทรงสำเร็จ',
      text: "Add a successful person",
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ตกลง'
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // )
        this.props.list();
        this.toggle()
      }
    })
    
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
        //   console.log(this.state.send_type)
        //   console.log(this.state.major_precent)
        //   console.log(this.state.name_present)
        //   console.log(this.state.send_name)
        //   console.log(this.state.send_uploadeword1)
        //   console.log(this.state.send_uploadepdf1)
        //   console.log(this.state.radio)


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="amber" size='sm' onClick={this.toggle}><MDBIcon icon="plus-square" />  แก้ไขข้อมูลผู้ทรงคุณวุฒิ</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}><Avatar src="https://cdn-icons-png.flaticon.com/512/4514/4514882.png" /> แก้ไขข้อมูลผู้ทรงคุณวุฒิ</MDBModalHeader>
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
              <div className='text-black'>
              <br/>
           
                    

                            <div className="mb-2">
                           <label className="black-text"><strong>ชื่อผู้ทรงคุณวุฒิ</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_name} name="name"
                                    value={this.state.name_expert} placeholder="กรุณาระบุชื่อผู้ทรงคุณวุฒิ" required />
                            </div>
                  

                           <div className="mb-2">
                           <label className="black-text"><strong>Username</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_username} name="username"
                                    value={this.state.username_expert} placeholder="กรุณาระบุ Username" required />
                            </div>

                            <div className="mb-2">
                           <label className="black-text"><strong>Password</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_password} name="password"
                                    value={this.state.password_expert} placeholder="กรุณาระบุ Password" required />
                            </div>

                            <div className="mb-2">
                           <label className="black-text"><strong>สังกัด</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_affiliation} name="affiliation"
                                    value={this.state.affiliation_expert} placeholder="กรุณาระบุ สังกัด" required />
                            </div>

                            <div className="mb-2">
                           <label className="black-text"><strong>ความเชียวชาญ</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_expertise} name="expertise"
                                    value={this.state.expertise_expert} placeholder="กรุณาระบุ ความเชียวชาญ" required />
                            </div>

                            <div className="mb-2">
                           <label className="black-text"><strong>เบอร์โทร</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_tel} name="tel"
                                    value={this.state.tel_expert} placeholder="กรุณาระบุ เบอร์โทร" required />
                            </div>




                 
              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                 <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
